import { FunctionComponent as F } from "react";
import TableRow from '@mui/material/TableRow';
import { DraggableProvided } from "react-beautiful-dnd";
import Checkbox from '@mui/material/Checkbox';
import TableCell from "@mui/material/TableCell";
import { Typography } from "@mui/material";
import { MmProtocolDosing } from "../../core/http/mmProtocol";
import { DosingRowState } from "@protoplan/types";


interface IProps
{
  mmProtocolId: number,
  row: MmProtocolDosing & DosingRowState,
  rowIndex: number,
  headers: { accessor: string, Header: string }[],
  handleCheck: (checked: boolean) => void;
  provided?: DraggableProvided
}

const MmProtocolTableRow: F<IProps> = props =>
{
  const handleCheck = () =>
  {
    props.handleCheck(!props.row?.checked);
  };

  if(!props.row)
    return <TableRow key={props.rowIndex}/>;



  return (
    <TableRow>
      {props.headers.map((header, index) =>
      {
        const label = header.accessor;

        switch(label)
        {
        case "suppName":
          return(
            <TableCell
              size='small'
              key={index}
              style={{ width: 300, paddingLeft: 10, paddingRight: 10, paddingBottom: 3 }}>
              <Typography variant='body2' display='inline' id='Supplement'>
                {props.row.suppName || "-"}
              </Typography>
            </TableCell>);
        case "dose":
          return (
            <TableCell
              size='small'
              key={index}
              style={{ width: 5, paddingLeft: 10, paddingRight: 10 }}>
              <Typography variant='body2' display='inline' id='Dose'>
                {props.row.dose || "-"}
              </Typography>
            </TableCell>);
        case "doseUnit":
          return (
            <TableCell
              size='small'
              key={index}
              style={{ width: 5, paddingLeft: 10, paddingRight: 10 }}>
              <Typography variant='body2' display='inline' id='DoseUnit'>
                {props.row.doseUnit}
              </Typography>
            </TableCell>);
        case "dosesPerDay":
          return (
            <TableCell
              size='small'
              key={index}
              style={{ width: 50, paddingLeft: 10, paddingRight: 0 }}>
              <Typography variant='body2' display='inline' id='DosesPerDay'>
                {props.row.dosesPerDay || "-"}
              </Typography>
            </TableCell>);
        case "daysPerMonth":
          return (
            <TableCell
              size='small'
              key={index}
              style={{ width: 5, paddingLeft: 10, paddingRight: 10 }}>
              <Typography variant='body2' display='inline' id='DaysPerMonth'>
                {props.row.daysPerMonth.toFixed()}
              </Typography>
            </TableCell>);
        case "checked":
          return (
            <TableCell
              size='small'
              key={index}
              style={{ width: 3, paddingLeft: 0, paddingRight: 10, paddingBottom: 7 }}>
              <Checkbox
                style={{ height: 15 }}
                checked={props.row?.checked}
                onChange={handleCheck}/>
            </TableCell>);
        }
      })}
    </TableRow>);
};




export default MmProtocolTableRow;
